import * as tslib_1 from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
const success = {
    text: '拼团成功',
    html: `可在常青藤爸爸APP/常青藤爸爸服务号"我的订单"中查看`,
};
const fail = {
    text: '拼团失败！',
    html: `拼团失败，退款将在15个工作日内原路返还`,
};
const unJoined = {
    text: '此团已满！',
    html: ``,
};
let SepllRow = class SepllRow extends Vue {
    constructor() {
        super(...arguments);
        this.pinStatus = { success, fail, unJoined };
    }
    get state() {
        if (this.groupDetail.status === 'success') {
            if (this.groupDetail.joined) {
                return 'success';
            }
            return 'unJoined';
        }
        return this.groupDetail.status;
    }
    async created() { }
};
tslib_1.__decorate([
    Prop({ default: {} })
], SepllRow.prototype, "groupDetail", void 0);
tslib_1.__decorate([
    Prop({ default: {} })
], SepllRow.prototype, "tempActivity", void 0);
SepllRow = tslib_1.__decorate([
    Component
], SepllRow);
export default SepllRow;
